import React from 'react';
import { Link } from 'react-router-dom';
import { FaChartLine, FaPiggyBank, FaBriefcase, FaArrowRight } from 'react-icons/fa';

const InvestmentSection = () => {
    const investmentCards = [
        {
            title: "Stocks Investment",
            description: "Direct equity trading and long-term portfolio growth strategies tailored to market trends...",
            icon: <FaChartLine size={32} className="text-warning mb-3" />,
            path: "/stock-investment",
            bgColor: "#fff3e0"
        },
        {
            title: "Mutual Funds",
            description: "Systematic investment plans (SIPs) and diversified fund management for steady wealth creation...",
            icon: <FaPiggyBank size={32} className="text-info mb-3" />,
            path: "/mutual-funds-investment",
            bgColor: "#e1f5fe"
        },
        {
            title: "PMS (Portfolio Management)",
            description: "Professional, personalized equity portfolios managed actively for high-net-worth investors...",
            icon: <FaBriefcase size={32} className="text-primary mb-3" />,
            path: "/portfolio-management-services",
            bgColor: "#ede7f6"
        }
    ];

    return (
        <section className="investment-section position-relative py-5 overflow-hidden bg-white">

            {/* Decorative Floating Animated Background Circles */}
            <div className="position-absolute rounded-circle opacity-50 floating-circle-1" style={{ width: '120px', height: '120px', backgroundColor: '#ffcdd2', top: '15%', left: '5%', zIndex: 0 }}></div>
            <div className="position-absolute rounded-circle opacity-25 floating-circle-2" style={{ width: '180px', height: '180px', backgroundColor: '#ffe082', top: '5%', right: '25%', zIndex: 0 }}></div>
            <div className="position-absolute rounded-circle opacity-40 floating-circle-3" style={{ width: '90px', height: '90px', backgroundColor: '#f8bbd0', bottom: '10%', right: '10%', zIndex: 0 }}></div>

            <div className="container py-5 position-relative" style={{ zIndex: 1 }}>
                <div className="row align-items-center">

                    {/* Left Title & Subtitle Column */}
                    <div className="col-lg-4 mb-5 mb-lg-0">
                        <span className="text-danger fw-bold small text-uppercase tracking-wider">What We Can Do For You</span>
                        <h2 className="display-5 fw-bold text-dark mt-2 mb-3" style={{ letterSpacing: '-1px', lineHeight: '1.2' }}>
                            Investments we can help you with
                        </h2>
                        <p className="text-muted small">
                            Build a resilient financial future through expert guidance, disciplined asset allocation, and customized market opportunities.
                        </p>
                    </div>

                    {/* Right Cards Staggered Diagonal Grid Column */}
                    <div className="col-lg-8 position-relative investment-wrapper">

                        <div className="bg-circle"></div>
                        <div className="pink-circle"></div>
                        <div className="yellow-circle"></div>

                        <div className="row">

                            {investmentCards.map((card, index) => (
                                <div
                                    key={index}
                                    className={`col-lg-4 investment-col card-${index + 1}`}
                                >
                                    <div className="investment-card shadow-sm" style={{ backgroundColor: card.bgColor }}>

                                        <div className="investment-icon">
                                            {card.icon}
                                        </div>

                                        <h4>{card.title}</h4>

                                        <p>
                                            {card.description}
                                        </p>

                                        <Link
                                            to={card.path}
                                            className="investment-link"
                                        >
                                            <span></span>
                                            Read More
                                            <FaArrowRight size={12} />
                                        </Link>

                                    </div>
                                </div>
                            ))}

                        </div>

                    </div>

                </div>
            </div>

            {/* CSS Animation Keyframes */}
            <style>{`
                @keyframes floatSlow {
                    0% {
                        transform: translateY(0px) translateX(0px) scale(1);
                    }
                    50% {
                        transform: translateY(-15px) translateX(10px) scale(1.05);
                    }
                    100% {
                        transform: translateY(0px) translateX(0px) scale(1);
                    }
                }

                @keyframes floatFast {
                    0% {
                        transform: translateY(0px) translateX(0px) scale(1);
                    }
                    50% {
                        transform: translateY(12px) translateX(-12px) scale(0.95);
                    }
                    100% {
                        transform: translateY(0px) translateX(0px) scale(1);
                    }
                }

                .floating-circle-1 {
                    animation: floatSlow 6s ease-in-out infinite;
                }

                .floating-circle-2 {
                    animation: floatFast 4s ease-in-out infinite;
                }

                .floating-circle-3 {
                    animation: floatSlow 5s ease-in-out infinite;
                }
            `}</style>
        </section>
    );
};

export default InvestmentSection;